import React from 'react';
import ChapterLayout from './ChapterLayout';
import { chapterTemplates } from '../../data/chapterTemplates';
import { leadership, alumni, gallery } from '../../data/cornell';

const Cornell = () => (
  <ChapterLayout
    chapter={chapterTemplates.cornell}
    leadership={leadership}
    alumni={alumni}
    gallery={gallery}
  />
);

export default Cornell;
